import Modal from "@mui/material/Modal";
import { styled } from "@mui/system";
import React, { useState } from "react";

import { useSelector } from "react-redux";
import { BackSvg, ClearSvg } from "../../../../utility/constants/assetsManager";
import {
  bgColor,
  colorWhite,
} from "../../../../utility/constants/colorManager";
import ResizeListner from "../../../../utility/ResizeListner";

import ConfirmationModal from "./ConfirmationModal";
const Backdrop = styled("div")`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgb(29, 45, 68, 0.6);
  -webkit-tap-highlight-color: transparent;
`;

function CustomModal({
  children,
  open,
  onClose,
  viewMoreStyle,
  containerStyle,
  isHeaderRequired = true,
  headerTitle,
  isConfirmationModalRequired = false,
  headerImage,
  onClickBack,
  isBackRequired = false,
}) {
  const { width, height } = ResizeListner();
  const [openConfirmModal, setOPenConfirmModal] = useState(false);
  const currentModalStep = useSelector((state) => state.modalNavSlice);

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          isConfirmationModalRequired ? setOPenConfirmModal(true) : onClose();
        }}
        BackdropComponent={Backdrop}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "0px solid gray",
          ...viewMoreStyle,
        }}
        onBackdropClick={() => {
          isConfirmationModalRequired ? setOPenConfirmModal(true) : onClose();
        }}
      >
        <div
          style={{
            width: width * 0.5,
            height: height * 0.5,
            backgroundColor: colorWhite,
            padding: "20px 20px 20px 20px",
            borderRadius: 15,
            ...containerStyle,
          }}
        >
          {isHeaderRequired && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                margin: "10px 0px",
              }}
            >
              {isBackRequired && currentModalStep !== 1 && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    borderRadius: 5,
                    cursor: "pointer",
                    marginRight: 30,
                    position: "absolute",
                    left: 10,
                  }}
                  onClick={onClickBack}
                >
                  <img
                    src={BackSvg}
                    style={{
                      width: 30,
                      height: 30,
                    }}
                    alt=""
                  />
                </div>
              )}
              {headerImage ? (
                headerImage
              ) : (
                <p
                  style={{
                    textAlign: "center",
                    fontWeight: "500",
                    fontSize: 16,
                    marginRight: 10,
                  }}
                >
                  {headerTitle}{" "}
                </p>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  borderRadius: 5,
                  cursor: "pointer",
                  position: "absolute",
                  right: 0,
                }}
                onClick={() => {
                  isConfirmationModalRequired
                    ? setOPenConfirmModal(true)
                    : onClose();
                }}
              >
                <img
                  src={ClearSvg}
                  style={{
                    width: 30,
                    height: 30,
                  }}
                  alt=""
                />
              </div>
            </div>
          )}
          {children}
        </div>
      </Modal>
      {openConfirmModal && isConfirmationModalRequired && (
        <ConfirmationModal
          containerStyle={containerStyle}
          openConfirmModal={openConfirmModal}
          onclose={() => {
            setOPenConfirmModal(false);
          }}
          onPressCancel={() => {
            setOPenConfirmModal(false);
          }}
          onPressOk={() => {
            onClose();
          }}
        />
      )}
    </>
  );
}

export default CustomModal;
